import { Smartphone, PhoneCall, LucideIcon } from "lucide-react";
import { useGet } from "../../../../hooks/useGet";
import { useFilterContext } from "../../../../context/FilterContextSub";
import { useMemo } from "react";
import Loading from "../../../../components/Loading";
import Card from "./Card";

interface ApiResponse {
  data: {
    total_mo: number;
    total_mt: number;
  };
}

interface MetricsData {
  data: {
    total_mo: number;
    total_mt: number;
  };
}

const Cards = () => {
  const { appliedCompany, appliedStartDate, appliedEndDate } =
    useFilterContext();

  const queryParams = useMemo(() => {
    const params = new URLSearchParams();

    if (appliedStartDate) params.append("startDate", appliedStartDate);
    if (appliedEndDate) params.append("endDate", appliedEndDate);

    return params.toString();
  }, [appliedStartDate, appliedEndDate]);

  const { data, isLoading } = useGet<ApiResponse[]>(
    `/admin/metrics?${queryParams}`,
    ["card_metrics", queryParams]
  );

  if (isLoading) {
    return <Loading />;
  }

  const metricsData = data?.[0]?.data as MetricsData["data"] | undefined;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto p-4">
      <Card
        title="Mobile Originated"
        value={metricsData?.total_mo ?? 0}
        icon={Smartphone}
        iconColor="text-blue-600"
      />
      <Card
        title="Mobile Terminated"
        value={metricsData?.total_mt ?? 0}
        icon={PhoneCall}
        iconColor="text-green-600"
      />
    </div>
  );
};

export default Cards;
